// extracted by mini-css-extract-plugin
module.exports = {"title":"excursion-module--title--1o8Ja","subTitle":"excursion-module--subTitle--1EDNL"};